import LoginForm from "../../forms/login/LoginForm";
import { Fragment } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { useLangContext } from "../../context/langContext";
import compInfo from "./jsons/login.json";

export default function LoginPage() {
  const { dir, lang } = useLangContext();
  const info = compInfo[lang];
  return (
    <Fragment>
      <Stack
        sx={{
          my: "8px",
          justifyContent: "start",
          alignItems: "start",
          width: "100%",
        }}
      >
        <img src="/images/navanak.svg" style={{ scale: ".8" }} />
      </Stack>
      <Stack
        dir={dir}
        direction="column"
        alignItems="start"
        justifyContent="start"
        width="90%"
        px={{ xs: "10px", md: "0" }}
      >
        <Typography variant="captionMediumBold" mb="20px">
          ورود به پنل ادمین نوانک
        </Typography>
      </Stack>

      <LoginForm />
    </Fragment>
  );
}
